import template from './ws-multiple-input.tmpl.html';
import controller from './ws-multiple-input.controller';

const WsMultipleInputComponent = {
  template,
  controller,
  transclude: true,
  bindings: {
    numberOfInputs: '@',
    onCompleted: '&',
    isReadonly: '<',
    forceSingleInput: '<?',
    value: '<',
    autoFocus: '<',
  },
};

export default WsMultipleInputComponent;



// WEBPACK FOOTER //
// ./src/multiple-input/ws-multiple-input.component.js